var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 9 9",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.390274 4.09756C0.390274 2.05007 2.0501 0.390244 4.09759 0.390244C6.14509 0.390244 7.80491 2.05007 7.80491 4.09756C7.80491 4.18726 7.80172 4.27621 7.79546 4.36431L7.93786 4.24052L8.17439 4.51262C8.18812 4.37613 8.19515 4.23767 8.19515 4.09756C8.19515 1.83454 6.36061 0 4.09759 0C1.83457 0 3.05176e-05 1.83454 3.05176e-05 4.09756C3.05176e-05 6.36058 1.83457 8.19512 4.09759 8.19512C5.1524 8.19512 6.11412 7.79656 6.84037 7.14181L6.58429 6.84724C5.92661 7.44239 5.05444 7.80488 4.09759 7.80488C2.0501 7.80488 0.390274 6.14506 0.390274 4.09756Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21954 6.82927C7.21954 7.04479 7.04482 7.21951 6.8293 7.21951C6.61377 7.21951 6.43905 7.04479 6.43905 6.82927C6.43905 6.61374 6.61377 6.43902 6.8293 6.43902C7.04482 6.43902 7.21954 6.61374 7.21954 6.82927Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14913 3.28696C7.23701 3.2246 7.35881 3.24528 7.42118 3.33316L8.0004 4.14934L8.57961 3.33316C8.64198 3.24528 8.76378 3.2246 8.85166 3.28696C8.93955 3.34933 8.96023 3.47113 8.89786 3.55901L8.2001 4.54224C8.18994 4.58767 8.16357 4.62965 8.12262 4.65872C8.08557 4.68501 8.0425 4.69654 8.0004 4.6945C7.95829 4.69654 7.91522 4.68501 7.87817 4.65872C7.83722 4.62965 7.81085 4.58767 7.80069 4.54224L7.10293 3.55901C7.04056 3.47113 7.06125 3.34933 7.14913 3.28696Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.ce5b1eadf644e42158ea9df1fe2d67e4.svg";
export { ForwardRef as ReactComponent };